import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ImportService } from '@services/imports/import.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { CompositionService } from '@services/compositions/composition.service';
import { CompositionTypeService } from '@services/composition-types/composition-type.service';

@Component({
    selector: 'app-imports-detail',
    templateUrl: './imports-detail.component.html',
    styleUrls: ['./imports-detail.component.scss'],
    providers: [ImportService, ImportTypeService, CompositionService, CompositionTypeService],
    standalone: false
})
export class ImportsDetailComponent implements OnInit {

  public importElement: Models.Import | any;

  public jsonDetail: any;

  public jsonImportProperties: any;

  public pageActions: PageAction[];

  public compositions: any[];

  public compositionTypes: Models.CompositionType[];

  public isLoading = false;

  public title = 'Import :';

  constructor(
    private importService: ImportService,
    private importTypeService: ImportTypeService,
    public compositionService: CompositionService,
    public compositionTypeService: CompositionTypeService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.importService.get(this.route.snapshot.params['id']).then(importItem => {
      this.importElement = importItem;
      this.jsonDetail = this.importElement.detail;
      this.jsonImportProperties = this.importElement.importProperties;
      this.getImportTypeTitle();
      this.getConnectedCompositions();
      this.createPageActions();
      this.isLoading = false;
    });
  }

  public navigateToComposition(composition_id: string) {
    this.router.navigate(['compositions', composition_id]);
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'edit',
        title: 'Edit',
        callback: () => {
          this.router.navigate(['imports/', this.importElement._id, 'edit']);
        }
      }),
      new PageAction({
        icon: 'folder',
        title: 'Explore Content',
        callback: () => {
          this.router.navigate(['imports/', this.importElement._id, 'explore']);
        }
      }),
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Import Type',
        callback: () => {
          this.router.navigate(['import-types/', this.importElement.typeId]);
        }
      }),
      new PageAction({
        icon: 'link',
        title: 'import-connections ',
        callback: () => {
          this.router.navigate(['imports/', this.importElement._id, 'connection'],
            { queryParams: { 'title': this.importElement.title } });
        }
      }),
      new PageAction({
        icon: 'receipt',
        title: 'Logs',
        callback: () => {
          this.router.navigate(['import-logs/', 'importId', this.importElement._id]);
        }
      }),
      new PageAction({
        icon: 'rowing',
        title: 'Execute',
        callback: () => {
          this.importService.patch(this.importElement.getId(), {}, { query: { execute: true } });
        }
      })
    ];
  }

  private getImportTypeTitle() {

    this.importTypeService.get(this.importElement.typeId).then(importTypeItem => {
      this.title = 'Imports: ' + importTypeItem.title + ' -> ' + this.importElement.title;
    });
  }

  private getConnectedCompositions() {

    this.compositionService.find(0, 100, { importIds: this.importElement._id }).then(responseComposition => {
      if (!responseComposition.data.length) {
        return;
      }
      this.compositions = responseComposition.data;

      this.compositionTypeService.find(0, 1, { _id: this.compositions[0].typeId }).then(responseCompositionType => {
        this.compositionTypes = responseCompositionType.data;

        this.compositions.map(entry => {
          entry.type = this.compositionTypes.filter(type => {
            return type._id === entry.typeId;
          })[0];
        });
      });
    });
  }

}
